import React from 'react';

import { useMediaQuery } from 'ha/helpers/MediaQuery';

import NavBarDesktop from '../containers/NavBarDesktop.lazy';
import NavBarMobile from '../containers/NavBarMobile.lazy';

interface Props {
  hasStickyNav?: boolean;
  showMiddleMenu?: boolean;
  showSearchBar?: boolean;
}

export const NavBar: React.FC<Props> = ({
  hasStickyNav,
  showMiddleMenu,
  showSearchBar,
}) => {
  const { md } = useMediaQuery();

  return md ? (
    <NavBarDesktop
      hasStickyNav={hasStickyNav}
      showMiddleMenu={showMiddleMenu}
      showSearchBar={showSearchBar}
    />
  ) : (
    <NavBarMobile showSearchBar={showSearchBar} />
  );
};

export default NavBar;
